import { useCallback } from 'react'

type StorageType = 'session' | 'local'

type UseStorageReturnValue = {
  storageGetItem: (key: string, type?: StorageType) => string
  storageSetItem: (key: string, value: string, type?: StorageType) => boolean
  storageRemoveItem: (key: string, type?: StorageType) => void
}

const useStorage = (): UseStorageReturnValue => {
  const storageType = (type?: StorageType): 'localStorage' | 'sessionStorage' =>
    `${type ?? 'session'}Storage`

  const storageGetItem = useCallback(
    (key: string, type?: StorageType): string => {
      return typeof window !== 'undefined'
        ? window[storageType(type)][key] ?? ''
        : ''
    },
    []
  )

  const storageSetItem = useCallback(
    (key: string, value: string, type?: StorageType): boolean => {
      if (typeof window !== 'undefined') {
        window[storageType(type)].setItem(key, value)

        return true
      }

      return false
    },
    []
  )

  const storageRemoveItem = (key: string, type?: StorageType): void => {
    if (typeof window !== 'undefined') {
      window[storageType(type)].removeItem(key)
    }
  }

  return {
    storageGetItem,
    storageSetItem,
    storageRemoveItem,
  }
}

export default useStorage
